import { dataModels } from '../../dataModels'
import { actionTypes } from './actions'
import { util } from '../../util'

const initialState = {
    store_filters: dataModels.getStoreFilters(),
    store_marketplaces: [],
    store_equipments: [],
    marketplaces: [],
    devices: [],
    store_loading: false,
    stores_list: [],
    count: 0,
    pageNo: 1,
    size: 10,
    order: 'desc',
    orderBy: 'store_id',
    store_error: '',
    store_details: {},
    fetch_store_failed: false,
    store_cities_loading: false,
    store_zip_codes_loading: false,
    equipments_loading: false,
    marketplaces_loading: false,
}

export const storesReducer = (state = initialState, action) => {
    const { type, payload } = action
    const { shallowHelper } = util
    switch (type) {
        case actionTypes.INITIAL_STORE_FILTERS: {
            return shallowHelper(state, {
                store_filters: payload,
                initial_store_filters: payload,
            })
        }

        case actionTypes.CLEAR_STORE_FILTERS: {
            return shallowHelper(state, {
                store_filters: dataModels.getStoreFilters(),
            })
        }

        case actionTypes.UPDATE_STORE_FILTERS: {
            return shallowHelper(state, {
                store_filters: payload,
            })
        }

        case actionTypes.FETCH_STORE_EQUIPMENTS_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
            })
        }

        case actionTypes.FETCH_STORE_MARKETPLACES_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
            })
        }

        case actionTypes.EQUIPMENTS_LOADING_START: {
            return shallowHelper(state, {
                equipments_loading: true,
            })
        }

        case actionTypes.EQUIPMENTS_LOADING_END: {
            return shallowHelper(state, {
                equipments_loading: false,
            })
        }

        case actionTypes.MARKETPLACES_LOADING_START: {
            return shallowHelper(state, {
                marketplaces_loading: true,
            })
        }

        case actionTypes.MARKETPLACES_LOADING_END: {
            return shallowHelper(state, {
                marketplaces_loading: false,
            })
        }

        case actionTypes.STORE_CITIES_LOADING_START: {
            return shallowHelper(state, {
                store_cities_loading: true,
            })
        }

        case actionTypes.STORE_CITIES_LOADING_END: {
            return shallowHelper(state, {
                store_cities_loading: false,
            })
        }

        case actionTypes.STORE_ZIP_CODES_LOADING_START: {
            return shallowHelper(state, {
                store_zip_codes_loading: true,
            })
        }
        case actionTypes.STORE_ZIP_CODES_LOADING_END: {
            return shallowHelper(state, {
                store_zip_codes_loading: false,
            })
        }

        case actionTypes.STORE_LOADING_START: {
            return shallowHelper(state, { store_loading: true })
        }

        case actionTypes.STORE_LOADING_END: {
            return shallowHelper(state, { store_loading: false })
        }

        case actionTypes.SAGA_FETCH_STORES_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
                store_error: '',
                store_loading: false,
            })
        }

        case actionTypes.STORE_ERROR: {
            return shallowHelper(state, {
                store_error: payload,
            })
        }

        case actionTypes.FETCH_STORE_BY_ID_SUCCESS: {
            /** following update will trigger the store details page to re-render */
            return shallowHelper(state, {
                store_loading: false,
                store_details: payload,
                fetch_store_failed: false,
            })
        }

        case actionTypes.FETCH_STORE_BY_ID_FAILED: {
            return shallowHelper(state, {
                store_loading: false,
                fetch_store_failed: true,
            })
        }

        case actionTypes.DISPATCH_CLEAR_STORE_FILTERS: {
            const filters = state.store_filters.map(filter => ({
                ...filter,
                display_value: filter.type !== 'string' ? [] : '',
                post_value: filter.type !== 'string' ? [] : '',
            }))

            return shallowHelper(state, { store_filters: filters })
        }

        case actionTypes.FETCH_STORE_DEVICES_SUCCESS: {
            return shallowHelper(state, {
                ...payload,
            })
        }

        default: {
            return state
        }
    }
}
